import { render } from "./BoxPrint.vue?vue&type=template&id=87e1e764&scoped=true"
import script from "./BoxPrint.vue?vue&type=script&lang=js"
export * from "./BoxPrint.vue?vue&type=script&lang=js"

import "./BoxPrint.vue?vue&type=style&index=0&id=87e1e764&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87e1e764"]])

export default __exports__